import useTranslation from "next-translate/useTranslation";
import { updateSetting, useSettings } from "../../redux/settings";

import Display from "../../components/ui/display";
import Toggle from "../../components/ui/toggle";

import styles from "./styles/Settings.module.css";

export default function GamePlay() {
  const { t: settingsT } = useTranslation("auth");

  const { autoQueening, sound, lastMove, pieceDestinations, premoves } =
    useSettings();

  return (
    <div className={styles.body}>
      <div className={styles.title}>{settingsT("Game behavior")}</div>
      <div className={styles.items}>
        <Display title={settingsT("Auto queen promotion")}>
          <Toggle
            active={autoQueening}
            onToggle={(isOn) => updateSetting("autoQueening", isOn)}
          />
        </Display>
        <Display title={settingsT("Sound")}>
          <Toggle
            active={sound}
            onToggle={(isOn) => updateSetting("sound", isOn)}
          />
        </Display>
        <Display title={settingsT("Highlight last move")}>
          <Toggle
            active={lastMove}
            onToggle={(isOn) => updateSetting("lastMove", isOn)}
          />
        </Display>
        <Display title={settingsT("Piece destinations")}>
          <Toggle
            active={pieceDestinations}
            onToggle={(isOn) => updateSetting("pieceDestinations", isOn)}
          />
        </Display>
        <Display title={settingsT("Premoves")}>
          <Toggle
            active={premoves}
            onToggle={(isOn) => updateSetting("premoves", isOn)}
          />
        </Display>
      </div>
    </div>
  );
}
